import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import AppBoxCollection from './App-box-collection';
import {execBI} from '../services/bi-events-manager';
import {popupShow} from '../actions/popup';
import _ from 'lodash';

const mainBg = images => {
  return images ? {backgroundImage: `url('${images.wideBackground}')`} : {};
};

class Collection extends React.Component {

  componentDidMount() {
    execBI('COLLECTIONS_LOADED', this.props.collection.apps);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isChange !== nextProps.isChange) {
      if (nextProps.isChange) {
        execBI('COLLECTIONS_CHANGE_OPEN');
      } else if (nextProps.popup.data.method !== 'success') {
        execBI('COLLECTIONS_CHANGE_CLOSE', {closing_method: nextProps.popup.data.method});
      }
    }

    if (!_.isEqual(this.props.collection.apps, nextProps.collection.apps)) {
      execBI('COLLECTIONS_LOADED', nextProps.collection.apps);
    }
  }

  /**
   * We don't have span element in React. It comes from CMS.
   */
  handleSpanChangePopup(ev) {
    if (ev.target.tagName === 'SPAN') {
      this.handleShowChangePopup(ev);
    }
  }

  handleShowChangePopup(ev) {
    ev.preventDefault();
    this.props.dispatch(popupShow('collections'));
  }

  render() {
    const verticalData = this.props.collection.data;
    const verticalApps = this.props.collection.apps;
    const vertical = this.props.vertical;

    return (
      <div className={classNames('apps-collection', {'no-main-app': verticalApps.length === 4, 'vertical-loading-done': verticalApps.length, 'collection-other': vertical === 'other'})}>

        <div className="background-img" style={mainBg(verticalData.images)}></div>

        <div className="container-collections">
          <h2 className="slogan" onClick={(ev) => this.handleSpanChangePopup(ev)} dangerouslySetInnerHTML={{__html: verticalData.titlePart2 || 'Powerful Apps To Grow Your Business'}}></h2>
          <a href="#" onClick={(ev) => this.handleShowChangePopup(ev)} className="collection-other-button">
            <FormattedMessage id="editor.collections.get.best"/>
          </a>

          {verticalApps.length === 5 ?
            <div className="main-app section section-pad-left">
              {verticalApps.filter((i, k) => k === 0).map((app) =>
                <div className="col col-1-4" key={app.slug}>
                  <AppBoxCollection isMain app={app} reviews={this.props.reviews} biPosition={0}/>
                </div>
              )}
            </div> : ''}

          {verticalApps.length ?
            <div className="secondary-apps section section-pad-left">
              {verticalApps.filter((i, k) => verticalApps.length === 4 || k !== 0).map((app, i) =>
                <div className="col col-1-4" key={app.slug}>
                  <AppBoxCollection isMain={false} app={app} reviews={this.props.reviews} biPosition={i + 1}/>
                </div>
              )}
            </div> : ''}

          <div className="collection-bottom-change">
            <span><FormattedMessage id="editor.collections.change"/> </span>
            <a className="collection-bottom-change-link" href="#" onClick={(ev) => this.handleShowChangePopup(ev)}>
              {vertical === 'other' ?
                <FormattedMessage id="editor.collections.find.best"/> :
                <FormattedMessage id="editor.collections.get.best"/>}
            </a>
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    dispatch: PropTypes.func,
    collection: PropTypes.object.isRequired,
    reviews: PropTypes.object,
    vertical: PropTypes.string,
    isChange: PropTypes.bool,
    popup: PropTypes.object
  };
}

function mapStateToProps(state) {
  return {
    collection: state.collection,
    reviews: state.reviews.all,
    vertical: state.mode.siteProfile.vertical,
    isChange: state.popup.type === 'collections',
    popup: state.popup
  };
}

export default connect(mapStateToProps)(Collection);



// WEBPACK FOOTER //
// ./components/Collection.js